module.exports = __webpack_public_path__ + "img/Frame 1116three3.54f364db.png";